import { DownloadOutlined } from "@ant-design/icons";
import { message } from "antd";
import { isEmpty } from "lodash";
import { isDownloadDisabled } from "modules/utilities/utility";
import moment from "moment";
import React from "react";
import { Button } from "react-bootstrap";

const DoctorDownload = ({ data }) => {
  const getStatus = (item) => {
    if (item.is_finished) {
      return "finished";
    } else if (item.is_auto_finished) {
      return "auto_finished";
    } else if (item.is_user_booked) {
      return "not_finished";
    } else if (item.is_rescheduled) {
      return "rescheduled";
    }
  };

  const exportCSV = () => {
    console.log("exportCSV");
    try {
      let csvRow = [];
      let rowName = [
        [
          encodeURIComponent("Customer Name"),
          encodeURIComponent("Scheduled At"),
          encodeURIComponent("Status"),
          encodeURIComponent("Doctor"),
          encodeURIComponent("Payment status"),
          encodeURIComponent("Created At"),
          encodeURIComponent("Last updated At"),
        ],
      ];

      for (let item = 0; item < data?.length; item++) {
        rowName.push([
          encodeURIComponent(data[item]?.user?.first_name || "N/A"),
          encodeURIComponent(
            moment(data[item]?.reminder_date).format("YYYY-MM-DD HH:mm:ss")
          ),
          encodeURIComponent(getStatus(data[item])),
          encodeURIComponent(data[item]?.assignment?.first_name || "N/A"),
          encodeURIComponent(data[item]?.payment_status),
          encodeURIComponent(
            moment(data[item]?.createdAt).format("YYYY-MM-DD HH:mm:ss")
          ),
          encodeURIComponent(
            moment(data[item]?.updatedAt).format("YYYY-MM-DD HH:mm:ss")
          ),
        ]);
      }

      for (let newitem = 0; newitem < rowName?.length; newitem++) {
        csvRow.push(rowName[newitem].join(","));
      }

      let csvString = csvRow.join("%0A");
      let anchorTag = document.createElement("a");
      anchorTag.href = "data:attachment/csv," + csvString;
      anchorTag.target = "_Blank";
      anchorTag.download = "doctor-bookings.csv";
      document.body.appendChild(anchorTag);
      anchorTag.click();
    } catch (error) {
      console.log(error);
      message.error("download error");
    }
  };

  return (
    <Button type="primary" onClick={exportCSV} disabled={ isDownloadDisabled || isEmpty(data) }>
      <div className="d-flex align-items-center">
        <span> Download </span>{" "}
        <span className="ms-1 mt-n1">
          {<DownloadOutlined />}
        </span>
      </div>
    </Button>
  );
};

export default DoctorDownload;
